import { inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { v4 as uuidv4 } from 'uuid';
import { getConfiguration } from '@lx/shared/tokens';
import { obfuscateText } from '@lx/quote-tool/shared/utils/functions';

@Injectable({
  providedIn: 'root',
})
export class UuidExtraInfoLoggingService {
  private readonly uuidExtraInfoLogging: string | boolean = false;

  private readonly uuid = uuidv4();

  private readonly configuration = getConfiguration();
  private readonly loggingService = inject(NGXLogger);

  constructor() {
    this.uuidExtraInfoLogging = this.configuration.FE_UUID_EXTRA_INFO_LOGGING;
  }

  getUuid() {
    return this.uuid;
  }

  logMessage(message?: string) {
    if (this.uuidExtraInfoLogging) {
      this.loggingService.info(`UUID EXTRA INFO User ${this.uuid} ${message}`);
    }
  }

  logCourseDetails(key: string, value: string) {
    if (this.uuidExtraInfoLogging) {
      this.logEnteredValueMessage(value, key);
    }
  }

  logStudentDetails(key: string, value: string) {
    if (this.uuidExtraInfoLogging) {
      let studentDetail: string;
      switch (key) {
        case 'email':
          studentDetail = obfuscateText(value, 3, true);
          break;
        case 'phoneNumber':
          studentDetail = obfuscateText(value, 7);
          break;
        default:
          studentDetail = obfuscateText(value, 3);
          break;
      }
      this.logEnteredValueMessage(studentDetail, key);
    }
  }

  private logEnteredValueMessage(value: string, key: string) {
    this.logMessage(`has entered ${value} as ${key}.`);
  }
}
